// extracted by mini-css-extract-plugin
module.exports = {"query":"style__query__-el8e"};